import { i18n } from "../i18n";
import { hasPendingLocalRequests } from "./localStore/client";

export async function waitForLocalSaves() {
  // Include Worker/backup requests and component queues; a Worker can be idle
  // between two saves while the component still has pending actions.
  const deadline = Date.now() + 30_000;
  do {
    await new Promise<void>((resolve) => setTimeout(resolve, 50));
    if (!hasPendingLocalRequests() && !document.querySelector('[data-save-state="saving"]')) {
      if (document.querySelector('[data-save-state="error"], [data-save-state="dirty"] [role="alert"]'))
        throw new Error(i18n.t("signOutSaveFailed", { ns: "auth" }));
      return;
    }
  } while (Date.now() < deadline);
  throw new Error(i18n.t("signOutSaveTimeout", { ns: "auth" }));
}
